export const ACTIVE = 'ACTIVE';

export const INACTIVE = 'INACTIVE';

export const NOT_ALLOWED = 'NOT_ALLOWED';
